const encryptor = require('simple-encryptor')(process.env.REACT_APP_HASH)

export default encryptor
